import { Component } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { AppContext } from '../../models/appContext';
import { GlobalService } from '../../services/global.service';
import { UserSystemInfoDto } from '../../models/userSystemInfoDtos';

@Component({
  selector: 'app-user-system',
  templateUrl: './user-system.component.html',
  styleUrl: './user-system.component.scss',
})

export class UserSystemComponent {
  systems: any;
  selectedSystemId!: number;

  constructor(
    private readonly commonService: CommonService, 
    private readonly dialog: MatDialog, 
    private readonly dialogRef: MatDialogRef<UserSystemComponent>, 
    private readonly globalVariable: GlobalService
  ) { }

  ngOnInit(): void {
    this.getAllSystemInfo();
  }

  getAllSystemInfo(): void {
    this.commonService.getUserSystemInfo().subscribe({
      next:(response:UserSystemInfoDto) => {
        this.systems = response.imagingSystems;
      },
      error:(error) => {
        this.commonService.showMessage("Error while retrieving user info","error");
        console.error('Error fetching system info:', error);
      }
  });
  }

  changeSystem(selectedSystem: any): void {
    this.selectedSystemId = selectedSystem.systemId;
    this.globalVariable.setSelectedSystemId = this.selectedSystemId.toString();
    localStorage.setItem('SelectedSystemId', selectedSystem.systemId.toString());
    localStorage.setItem('SelectedSystemName', selectedSystem.systemName);
    this.callRegisterPrincipal(this.selectedSystemId);
  }

  callRegisterPrincipal(systemId: number): void {
    this.commonService.callRegisterPrincipal(systemId).subscribe({
      next: (response) => {
        AppContext.userDetails = response;
        AppContext.userDetails.systemId = systemId;
        this.globalVariable.setUserDetails = AppContext.userDetails;
        this.globalVariable.configureUserAccess(AppContext.userDetails);
        this.onCancelClick();
      },
      error: (error) => {
        this.commonService.openErrorDialog(error.error.message);
        this.commonService.showMessage('User registration failed', 'error');
      }
    });
  }

  openErrorDialog(SystemName: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: {
        title: 'ERROR',
        message: `You do not have access to ${SystemName}.`,
        showOkButton: true,
        showCancelButton: false,
        showSubmitButton: false,
      },
    });

    dialogRef.afterClosed().subscribe();
  }

  onCancelClick(): void {
    this.dialogRef.close('ok');
  }
}
